// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__3DU9s","footerWrapper":"Footer_footerWrapper__C4Ben","footerQrCode":"Footer_footerQrCode__OxrV7","qrCod":"Footer_qrCod__4V7-i"};